module.exports = __webpack_public_path__ + "static/media/Workday_Step2a_Image2m.1ebf9db7.jpg";